import $ from 'jquery'

$(document).ready(function() {
	if (!$('body').hasClass('page-template-page-gallery')) {
		return
	}
	const inst = $('[data-remodal-id=gallery-modal]').remodal({
		hashTracking: false
	})
	const $imageContainer = $('#modal-image-container')
	$('.gallery-item').on('click', function(e) {
		e.preventDefault()

		$(this)
			.find('.image-holder')
			.each(function() {
				$imageContainer.append(`
						<div class="img-container">
					 	 <div class="image-area" style="background-image:url('${$(this).attr(
									'data-image'
								)}')"></div>
					 	 <div class="orbit-caption">${$(this).attr('data-text')}</div>
					  </div>
					`)
			})

		inst.open()
	})
	$(document).on('opening', '.gallery-modal', function(e) {
		$imageContainer.slick({
			dots: true,
			autoplay: true,
			arrows: false,
			infinite: true,
			speed: 500,
			autoplaySpeed: 4000,
			fade: true
		})
	})

	$(document).on('closed', '.gallery-modal', function(e) {
		$imageContainer.slick('unslick')
		$imageContainer.html('')
	})
})
